import usePayment from 'context/payment-context/hook'

export default function WorkbooksSummary() {
    const {packageItem} = usePayment()
    const {workbooksCount, workbooksAmount} = packageItem as any
    return (
        <div className='d-flex justify-content-between'>
            <p className='card-text fw-bold'>
                Cuadernos <small style={{fontSize: '12px'}}>({workbooksCount})</small>
            </p> 
            <p className='card-text'>
                $ {Number(workbooksAmount).toFixed(2)}
            </p>
        </div>
   )
}